import React from "react";
import TextInput from "./textInput";

const DeclineModal = ({ onClick, onSubmit, onChange }) => {
  return (
    <div className="modal-backdrop">
      <div className="decline-modal">
        <h2 className="margin-10 flex-container flex-center">
          Reason for Declination
        </h2>
        <TextInput onChange={onChange}></TextInput>
        <div className="flex-container flex-center gap-10 margin-10">
          <button className="button-class-white" onClick={onClick}>
            Cancel
          </button>
          <button className="button-class" onClick={onSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeclineModal;
